<div class="placeholder-container">
  <div class="placeholder-title">
    {{ titleKey | translate }}
  </div>
  <div class="placeholder-subtitle">
    {{ subtitleKey | translate }}
  </div>
</div>
